// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__2oszt","rotate":"styles_rotate__qUDlN","divloading":"styles_divloading__2r0BD"};